<template>
  <div class="tile loading"></div>
</template>

<script>
export default {
  name: "LoadingTile",
};
</script>
